import { render, staticRenderFns } from "./NotificationInformation.vue?vue&type=template&id=b3fe7332"
import script from "./NotificationInformation.vue?vue&type=script&lang=js"
export * from "./NotificationInformation.vue?vue&type=script&lang=js"
import style0 from "./NotificationInformation.vue?vue&type=style&index=0&id=b3fe7332&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports